import type {
  ICheckboxesDropdownMenu,
  IDropdownMenuInternalProps
} from "libs/design-system/src/types/Dropdown/dropdown_menu/dropdown-menu";
import { Button } from "../../../Button";
import styles from "./checkboxes.module.scss";

export const Checkboxes = (props: ICheckboxesDropdownMenu & IDropdownMenuInternalProps) => {

  const { closeDropdown } = (props as IDropdownMenuInternalProps);

  const { applyBtnText, onApplyHandler, lang, applyBtnDisabled } = props as ICheckboxesDropdownMenu;

  return (
    <div className={styles['apply-btn-wrapper']}>
      <Button
        size='sm'
        text={applyBtnText || (lang === 'ar' ? "تطبيق" : "Apply")}
        disabled={applyBtnDisabled}
        onClickHandler={() => {
          onApplyHandler?.();
          closeDropdown?.();
        }}
      />
    </div>
  )
}
